<app-menu [hasChanges]="loadMenu" title="Catálogo de productos"></app-menu>
<app-loading [show]="load"></app-loading>
<!-- div class="m-2">
    < <div class="flex flex-wrap bg-gray-50" >
        <div class="w-full md:w-4 p-2">
            <label>Categoría</label>
            <p-dropdown optionLabel="label" [options]="categorias" optionLabel="descripcion"
                placeholder="Seleccione la categoria" [(ngModel)]="selectedCategory" [showClear]="true"
                (onChange)="getCategoriaNivelN(2,selectedCategory?.idCategorizacionProveedor);this.selectedSubCategory={}; filter(busqueda.value)"></p-dropdown>
        </div>
        <div class="w-full md:w-4 p-2">
            <label>Subcategoría</label>
            <p-dropdown optionLabel="descripcion" [options]="subCategorias" [(ngModel)]="selectedSubCategory"
                [showClear]="true" placeholder="Seleccione la subcategoría"
                (onChange)="filter(busqueda.value)"></p-dropdown>
        </div>
        <div class="w-full md:w-4 flex">
            <div class="p-inputgroup pt-1">
                <p-checkbox [(ngModel)]="checkedUniqueInv" label="Visualizar productos 
                con inventario" icon="pi pi-filter" [binary]="true" (onChange)="filter(busqueda.value)" />
            </div>
        </div>

    </div> 
</div>-->
<div class="flex flex-wrap hidden md:flex m-2">
    <!-- Headers -->
    <div class="hidden md:flex md:w-2 justify-content-center">
        <label class="font-bold">Imagen</label>
    </div>
    <div class="hidden md:flex md:w-2 justify-content-center">
        <label class="font-bold">Código</label>
    </div>
    <div class="hidden md:flex md:w-4 justify-content-center">
        <label class="font-bold">Información de Producto</label>
        <!-- Descripción -->
    </div>
    <div class="hidden md:flex md:w-2 justify-content-center">
        <label class="font-bold">Precio</label>
    </div>
    <div class="hidden md:flex md:w-2 justify-content-center">
        <label class="font-bold">Cantidad</label>
    </div>
</div>
<div class="w-full text-center p-2 sticky top-menu">
    <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
        <input type="text" pInputText placeholder="Filtro de productos" #busqueda pSize="small" (input)="filter(busqueda.value)">
    </div>
</div>
<div class="flex flex-wrap m-2" *ngFor="let prod of listProductsPagination; let index =index">
    <!-- Detalle -->
    <div class="w-full flex md:w-2 align-items-center justify-content-center">
        <!-- Imagen -->
        <img src="{{prod.productoImagenes.length > 0 ? prod.productoImagenes[0].ubicacion:'assets/img/noImg.png'}}"
            style="width:100px" alt="">
    </div>
    <div class="w-full md:w-2 flex justify-content-center align-items-center">
        <b class="md:hidden">Código producto :</b> {{prod.codBarras}}<br>
    </div>

    <div class="w-full md:w-4 align-items-center pl-2 text-left">
        <p><b>{{prod.descripcionLarga}}</b><br>
            <b>Unidad de presentación :</b> {{prod.unidadPresentacion}}<br>
            <b>Marca :</b> {{prod.marca}}<br>
            <button pButton class="p-button p-button-link colorSimescco2" icon="pi pi-search" label="Ver movimientos"
                (click)="getRastreoProducto(prod)"></button>
        </p>
    </div>
    <div class="w-full md:w-4 flex flex-wrap align-items-center">
        <div class="w-6 flex justify-content-center">
            <!-- Precio Unitario-->
            <b class="md:hidden">Precio:</b> {{(prod.precioProducto.precioPromocion > prod.precioProducto.precio ?
            prod.precioProducto.precio: prod.precioProducto.precioPromocion ) | currency}}
        </div>
        <div class="w-6 flex justify-content-center">
            <b class="md:hidden">Cantidad:</b> {{prod.inventario}} &nbsp;{{prod.unidadPresentacion}}
        </div>
    </div>
    <div class="w-full text-center">
        <hr>
    </div>
</div>
<div class="md:fixed bottom-0 flex flex-rows bg-white mx-auto w-full justify-content-between text-xs">
    <div class="flex mx-auto">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [showCurrentPageReport]="true" [showPageLinks]="false" [showJumpToPageDropdown]="false"
            currentPageReportTemplate="Mostrando {last} de {totalRecords}" />
    </div>
    <div class="flex align-items-center mx-auto">
         <button *ngIf="urlDownload ==''" pButton  icon="pi pi-download"
            class="p-button p-button-success" (click)="getReporte()"></button><br>
        <a *ngIf="urlDownload !=''" href="{{urlDownload }}"><i class="pi pi-file-excel"></i>&nbsp;Descargar
            información</a> 
    </div>
</div>

<p-dialog header="Mensaje informativo" [(visible)]="bloqueo" [modal]="true" [dismissableMask]="false"
    [closeOnEscape]="false" [closable]="false">
    <div>
        <span [innerHtml]="msgInicial"></span>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check" label="Cerrar" class="p-button p-button-danger"
            (click)="redirigir()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Rastreo de producto" [(visible)]="viewRastreo" [modal]="true" [dismissableMask]="false"
    [closeOnEscape]="true" [closable]="true" [style]="{width: '90vw'}">
    <div>
        <div class="sticky pb-2">
            <h4>{{selectedProduct.descripcionLarga}} - {{selectedProduct.codBarras}}</h4>
        </div>
        <div *ngFor="let item of selectedProduct.movimientoTienda; let $index=index">
            <p>{{$index +1}}. {{item.fechaRegistro | date :'medium' }}: <b>{{item.descripcion + ' ' +
                    item.referencia}}</b> Cantidad:
                <b>{{item.valor}}</b>
            </p>
            <hr>
        </div>
        <button pButton icon="pi pi-check" label="Ver más información" class="p-button p-button-link colorSimescco2"
            (click)="getRastreoProducto(selectedProduct)"></button>
    </div>
    <ng-template #footer>

        <button pButton icon="pi pi-times" label="Cerrar" class="p-button p-button-danger"
            (click)="viewRastreo=false;"></button>
    </ng-template>
</p-dialog>

<!--Selección de tienda-->
<p-dialog header="Selección de ubicación de inventario" [(visible)]="divStoreSelection" [modal]="true"
    [dismissableMask]="false" [closeOnEscape]="false" [closable]="false" [style]="{height: '400px'}">
    <div>
        <label>Selección de ubicación</label>
        <p-select optionLabel="nombreTienda" [(ngModel)]="selectedStore" [options]="listStores"
            placeholder="Seleccione la ubicación"></p-select>

        <div class="p-message p-message-success" *ngIf="!!selectedStore?.nombreTienda"> Ha elégido la ubicación
            {{selectedStore?.nombreTienda}}</div>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check-circle" label="Continuar" class="p-button p-button-success"
            (click)="getInventarioStore(); "></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>
<!-- <app-footer></app-footer> -->